const React = require('react');

class WaitText extends React.Component {
    constructor(props) {
      super(props);
      this.state = {counter: 0, messages: [
        'Loading your screenshot...',
        "Making sure it's just right...",
        "This can take a little bit...",
        "I talk so much. How are things with you?",
        "I hope everything is good with you."
      ]};
    }

    componentDidMount() {
      this._isMounted = true;
      const that = this;
      function waitMore() {
        setTimeout(() => {
          if(that._isMounted)
          that.setState({ counter: that.state.counter + 1 }, () => waitMore());
        }, 2500);
      }
      waitMore();
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    render() {
      return <div>{this.state.messages[this.state.counter % this.state.messages.length]}</div>
    }
}

module.exports = WaitText;
